/**
 * VendorContactService
 * Service for managing vendor contacts
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor contact CRUD operations with vendor-specific queries
 */
export class VendorContactService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorContactService.DEFAULT_SERVICE_PATH,
            basePath: VendorContactService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all contacts for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor contact views
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all contacts for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor contact views
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
}
VendorContactService.DEFAULT_SERVICE_PATH = 'vendors';
VendorContactService.BASE_PATH = 'api/vendor-contacts';
//# sourceMappingURL=VendorContactService.js.map